export const SORTABLE_CLASSNAME = 'wrex-dnd-sortable';
